import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HotSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            热门连载
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            精选高分韩漫，口碑与热度双重保证，每一部都值得阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative aspect-[3/4] rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={comic.coverImage}
                alt={comic.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className={`inline-block text-xs font-medium px-2.5 py-1 rounded-full mb-2 ${
                  comic.status === '连载中'
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-600 text-background-100'
                }`}>
                  {comic.status}
                </span>
                <h3 className="text-lg font-heading font-bold text-background-50 mb-1">{comic.title}</h3>
                <div className="flex items-center gap-3 text-xs text-background-300">
                  <span>{comic.author}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    {comic.rating}
                  </span>
                </div>
              </div>
              <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-sm text-background-50 text-xs px-2.5 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-eye-line mr-1"></i>{comic.views}
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/fantasy"
            className="inline-flex items-center gap-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多热门漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}